<template>
  <div>
    <product-component-v2></product-component-v2>
  </div>

</template>

<script>
import ProductComponentV2 from "../components/payment/ProductComponentV2";

export default {
  name: "paymentV2",
  components: {ProductComponentV2}
}
</script>

<style scoped>

</style>
